import type { DocumentMetadataItem } from '@lds-efsp/shared-contracts';

const PARTICIPANT_CLASSES = new Set(['caseParticipant', 'caseAssignment']);

/**
 * Walter R84 (confirm flow): a fee-calc blocker the Confirm page itself can
 * satisfy must never be remedied only by a backward "Go to Upload Documents"
 * link. A blocker is confirm-fixable when it references a per-document
 * participant-class metadata code (FILING_PARTY / FILING_ATTORNEY / Refers-To
 * / Party Served / …): the Document Assignments section on the Confirm page
 * renders ALL participant-class fields (`includeAllPartyFields`), so those
 * complete in place. Everything else — document-type selection, file-level
 * issues, non-participant metadata like SERVICE_DATE — is satisfiable only on
 * Upload Documents in phase 1 and keeps the Upload jump.
 *
 * Classification is by the blocker's `field` path
 * (`documents[i].metadataValues.<CODE>`) resolved against the published
 * doc-type metadata registry; a registry miss falls back to the two assignment
 * codes, which are participant-class by definition.
 */
export function isConfirmFixableBlocker(
  err: { field: string },
  docTypeMetadata: Record<string, DocumentMetadataItem[]>,
): boolean {
  const match = err.field.match(/\.metadataValues\.([A-Za-z0-9_]+)$/);
  if (!match) return false;
  const code = match[1];
  for (const items of Object.values(docTypeMetadata)) {
    const item = items.find(i => i.code === code);
    if (item) return PARTICIPANT_CLASSES.has(item.classType);
  }
  return code === 'FILING_PARTY' || code === 'FILING_ATTORNEY';
}
